import { Button, Card, Input, Row, Spin } from "antd";
// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React, { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { LOG_TYPES } from "../../constants/logs";
import { WORKER_STAGES_REASONS_DATA } from "../../appV2/redesign/utils/worker";
import _ from "lodash";
import { getAuthHeader } from "../../utils/superagent";
import { isEmpty } from "lodash";
import moment from "moment-timezone";
import request from "superagent";
import styled from "styled-components";

const { TextArea } = Input;

const Container = styled.div`
  margin-top: 10px;
  margin-bottom: 20px;
`;

const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LogWrapper = styled.div`
  margin: 10px 0px;
`;

const CardContainer = styled(Card)`
  .ant-card-body {
    padding-bottom: 0px;
  }
`;

const Gray = styled.span`
  color: gray;
  margin-left: 10px;
  font-size: 12px;
`;

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'addedBy' implicitly has an 'any' type.
function PerformedBy({ addedBy, createdAt }) {
  return (
    <Row>
      <strong>{addedBy ? addedBy.email : "someone"}</strong>
      <Gray>{moment(createdAt).fromNow()}</Gray>
    </Row>
  );
}

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'text' implicitly has an 'any' type.
function Log({ text, createdAt, user }) {
  return (
    <LogWrapper>
      <PerformedBy addedBy={user} createdAt={createdAt} />
      {/* @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'i' implicitly has an 'any' type. */}
      {text.split("\n").map((i) => {
        return <p key={i}>{i}</p>;
      })}
    </LogWrapper>
  );
}

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'currentStatus' implicitly has an 'any' type.
function StatusLog({ currentStatus, previousStatus, reason, note, addedBy, createdAt, logType }) {
  return (
    <LogWrapper>
      {logType && logType === LOG_TYPES.STATUS ? (
        <>
          <span>
            <strong>Automated Log</strong>
          </span>
          <br />
        </>
      ) : (
        <PerformedBy addedBy={addedBy} createdAt={createdAt} />
      )}
      <span>
        Status changed{" "}
        {previousStatus && (
          <span>
            from <strong>{previousStatus.toLowerCase()}</strong>
          </span>
        )}{" "}
        to <strong>{currentStatus.toLowerCase()}</strong>
      </span>
      <br />
      <strong>Reason : </strong>{" "}
      {WORKER_STAGES_REASONS_DATA[currentStatus]?.[reason]?.description || "No Reason"}
      <br />
      <strong>Note : </strong> {note || "No Notes"}
    </LogWrapper>
  );
}

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'userId' implicitly has an 'any' type.
function LogContainer({ userId, currentUserId, type, currentStage }) {
  const [loading, setLoading] = useState(false);
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [logs, setLogs] = useState<any[]>([]);
  const [currentLog, setCurrentLog] = useState("");
  const [loader, setloader] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [lastLogId, setLastLogId] = useState<any>(null);

  const fetchLogsList = async () => {
    if (!userId) {
      return;
    }
    void request
      // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
      .get(`${global.api}/account-log/list`)
      .set(await getAuthHeader())
      .query({ accountID: userId, type, lastId: lastLogId })
      .then(updateLogs);
  };

  useEffect(() => {
    if (!userId) {
      return;
    }
    const getLogList = async () => {
      void request
        // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
        .get(`${global.api}/account-log/list`)
        .query({ accountID: userId, type })
        .set(await getAuthHeader())
        .then(updateLogs);
    };
    void getLogList();
  }, [userId, currentStage, type]);

  // @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'body' implicitly has an 'any' type.
  const updateLogs = ({ body }) => {
    if (!isEmpty(body)) {
      setloader(false);
      setLogs((prevLogs) => prevLogs.concat(body));
      setLastLogId(body[body.length - 1]._id);
    } else {
      setHasMore(false);
      setloader(false);
    }
  };
  const handleFetchMoreRecords = async () => {
    if (hasMore) {
      setloader(true);
      void fetchLogsList();
    } else {
      setloader(false);
      setHasMore(false);
    }
  };

  // @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'target' implicitly has an 'any' type.
  const onLogChange = ({ target }) => setCurrentLog(target.value);

  const addLog = async () => {
    setLoading(true);
    const { body: newLog } = await request
      // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
      .post(`${global.api}/account-log/create`)
      .set(await getAuthHeader())
      .send({
        type,
        text: currentLog,
        accountID: userId,
        addedBy: currentUserId,
      });

    setLogs([newLog, ...logs]);
    setCurrentLog("");
    setLoading(false);
  };

  return (
    <Container>
      <CardContainer title="Logs">
        <TextArea
          style={{ marginBottom: 10 }}
          value={currentLog}
          placeholder="start typing a new log item"
          rows={2}
          onChange={onLogChange}
        />
        {currentLog.length > 0 && (
          <Button block onClick={addLog} loading={loading}>
            Add Log
          </Button>
        )}
        {loading && (
          <Center>
            <Spin />
          </Center>
        )}
        <div className="log-spinner" style={{ height: loader && hasMore ? "330px" : "auto" }}>
          <div id="log-infinite-container" className="log-infinite-container">
            {/* @ts-expect-error FIXME this wrong type */}
            <InfiniteScroll
              dataLength={logs.length || 0}
              next={handleFetchMoreRecords}
              hasMore={!loader && hasMore}
              scrollableTarget="log-infinite-container"
            >
              {logs.map((log) =>
                log.logType === LOG_TYPES.STATUS ? (
                  <StatusLog key={log._id} {...log} />
                ) : (
                  <Log key={log._id} {...log} />
                )
              )}
            </InfiniteScroll>
          </div>
          {loader && hasMore && (
            <div className="log-loading-container">
              <Spin />
            </div>
          )}
        </div>
      </CardContainer>
    </Container>
  );
}

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'lastLogTime' implicitly has an 'any' type.
const getLastLogColumn = (lastLogTime) => {
  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter '_text' implicitly has an 'any' type.
  const renderLastLog = (_text, user) => {
    if (!lastLogTime) {
      return <Spin />;
    }

    const userLogTime = lastLogTime[user._id];
    return userLogTime ? moment(userLogTime.createdAt).fromNow() : "No Log";
  };

  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'a' implicitly has an 'any' type.
  const sortLastLog = (a, b) => {
    const userLogTimeA = _.get(lastLogTime, `${a._id}.createdAt`, "0");
    const userLogTimeB = _.get(lastLogTime, `${b._id}.createdAt`, "0");

    // eslint-disable-next-line no-nested-ternary
    return userLogTimeA > userLogTimeB ? 1 : userLogTimeA < userLogTimeB ? -1 : 0;
  };

  return {
    title: "Last Log",
    key: "lastLog",
    render: renderLastLog,
    sorter: sortLastLog,
  };
};

export { LogContainer, getLastLogColumn };
